import { Button } from "primereact/button";
import React, { useEffect, useMemo, useState } from "react";
import Loading from "../../../../components/Loading/Loading";
import ReviewsModal from "../../../../components/ReviewsModal/ReviewsModal";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import useGetCommentsOfProduct from "../../../../hooks/useGetCommentsOfProduct";
import { useToggle } from "../../../../hooks/useToggle";
import localeText from "../../../../locale";
import Comment from "../Comment/Comment";
import { ProgressBar } from "primereact/progressbar";
import useRatingProduct from "../../../../hooks/useRatingProduct";
import { Rating } from "primereact/rating";
import { set } from "@cloudinary/url-gen/actions/variable";

const ProductRatingComments = ({ productInfoID }) => {
  const { showErrorToast } = useToastContext();
  const { value, setAsFalse, setAsTrue } = useToggle();
  const { commentsOfProduct, isLoading } = useGetCommentsOfProduct({
    productId: productInfoID,
    onError: (code) => showErrorToast({ code }),
  });
  const [ratingProduct, setRatingProduct] = useState(null);
  const [ratingStars, setRatingStars] = useState({
    5: 0,
    4: 0,
    3: 0,
    2: 0,
    1: 0,
  });
  const { ratingProduct: ratingProductHook } = useRatingProduct({
    productId: productInfoID,
    onError: (code) => showErrorToast({ code }),
  });

  useEffect(() => {
    if (productInfoID) {
      setRatingProduct(ratingProductHook);
    } else {
      setRatingProduct(null);
    }
  }, [productInfoID, ratingProductHook, showErrorToast]);
  const countProductRatings = (ratings) => {
    const counts = {
      5: 0,
      4: 0,
      3: 0,
      2: 0,
      1: 0,
    };

    // Usamos reduce para iterar sobre o array e contar as ocorrências de cada rating
    ratings.forEach((rating) => {
      if (rating.rateproduct >= 1 && rating.rateproduct <= 5) {
        counts[rating.rateproduct]++;
      }
    });

    setRatingStars(counts);
  };
  useEffect(() => {
    if (commentsOfProduct.length > 0) {
      setRatingStars({
        5: 0,
        4: 0,
        3: 0,
        2: 0,
        1: 0,
      });
      countProductRatings(commentsOfProduct);
    }
  }, [commentsOfProduct]);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.substring(1);
  };

  const valueTemplate = (value) => {
    return <div></div>;
  };

  if (isLoading) return <Loading />;
  const firstFiveComments = commentsOfProduct.slice(0, 5);
  return (
    <>
      <ReviewsModal
        headerText={`${localeText("productReviews")} (${commentsOfProduct.length})`}
        setAsFalse={setAsFalse}
        visible={value}
        comments={commentsOfProduct}
      />
      <div id="productReviews" className={`bg-white`}>
        <hr style={{ borderTop: "solid 1px #B3BAC5" }}></hr>
        {firstFiveComments.length > 0 ? (
          <div className="font-bold text-xl mb-6" style={{ color: "#344563" }}>
            {capitalizeFirstLetter(localeText("ratings"))} {/* ({commentsOfProduct.length}) */}
          </div>
        ) : (
          <div className="font-bold text-xl mb-6" style={{ color: "#344563" }}>
            {capitalizeFirstLetter(localeText("noRatings"))} {/* ({commentsOfProduct.length}) */}
          </div>
        )}

        {firstFiveComments && firstFiveComments.length !== 0 && (
          <div className="grid grid-nogutter">
            <div className="col-12 md:col-5 flex flex-column gap-4">
              <div className="flex gap-3 align-items-center">
                <div className="font-bold title" style={{ fontSize: "3.5rem", color: "#28AB69" }}>
                  {ratingProduct?.rate ? parseFloat(ratingProduct?.rate.toFixed(1)) : 0}
                </div>
                <div className="flex flex-column gap-2">
                  <Rating
                    value={Math.floor(ratingProduct?.rate)}
                    readOnly
                    stars={5}
                    cancel={false}
                    className="green-rating"
                  />
                  <div style={{ color: "#7A869A" }}>
                    {commentsOfProduct.length} {localeText("ratings")}
                  </div>
                </div>
              </div>
              <div className="hidden md:flex flex-column gap-3 " style={{ maxWidth: "240px" }}>
                {[...Array(5)].map((_, i) => (
                  <div key={4 - i} className="grid grid-nogutter gap-5 align-items-center">
                    <div className="col">
                      <ProgressBar
                        value={(ratingStars[5 - i] * 100) / commentsOfProduct.length}
                        displayValueTemplate={valueTemplate}
                      ></ProgressBar>
                    </div>

                    <div
                      className="text-md font-bold flex align-items-start gap-2"
                      style={{ color: "#7A869A" }}
                    >
                      {5 - i} <i className="pi pi-star-fill text-lg"></i>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-column gap-5 col">
              {firstFiveComments.map((comment, i) => (
                <Comment
                  key={i}
                  comments={comment.comments}
                  dateorder={comment.dateorder}
                  rate={comment.rateproduct}
                  username={comment.username}
                />
              ))}
            </div>
            {commentsOfProduct.length > 5 && (
              <Button className="lg:mt-5 mt-3" onClick={setAsTrue}>
                {localeText("showMore")}
              </Button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ProductRatingComments;
